import { render, staticRenderFns } from "./EnvironmentDistribution.vue?vue&type=template&id=041f3992&"
import script from "./EnvironmentDistribution.vue?vue&type=script&lang=js&"
export * from "./EnvironmentDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports